module.exports = __webpack_public_path__ + "static/media/icon_influencer.ba668cb2.svg";